import React from "react";
import { Box, CircularProgress, useMediaQuery, useTheme } from "@mui/material";
import ChatSidebar from "./ChatSidebar";
import ChatWindow from "./ChatWindow";
import ModoEspiaoMobile from "../pages/ModoEspiaoMobile";

const ModoEspiao = ({
  contacts,
  selectedContact,
  onSelectContact,
  currentTab,
  endpointPrefix = "sdr",
  loadingContacts = false,
  setForceTokenExpired,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (loadingContacts) {
    return (
      <Box
        sx={{
          display: "flex",
          height: "calc(100vh - 160px)",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "background.paper",
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isMobile) {
    return (
      <ModoEspiaoMobile
        contacts={contacts}
        endpointPrefix={endpointPrefix}
        currentTab={currentTab}
        selectedContact={selectedContact}     // ← ADICIONE se necessário
        onSelectContact={onSelectContact}     // ← ADICIONE se necessário
      />
    );
  }
  else {
    return (
      <Box
        sx={{
          display: "flex",
          height: "min(760px, calc(100vh - 190px))",
          minHeight: 520,
          maxWidth: "100%",
          bgcolor: "background.paper",
          borderRadius: 2,
          overflow: "hidden",
          overflowX: "hidden",
          isolation: "isolate",
          border: "1px solid",
          borderColor: "divider",
          boxShadow: (theme) =>
            theme.palette.mode === "dark"
              ? "0 18px 45px rgba(0,0,0,0.35)"
              : "0 14px 38px rgba(15,23,42,0.08)",
        }}
      >
        <ChatSidebar
          contacts={contacts}
          onSelectContact={onSelectContact}
          currentTab={currentTab}
          selectedContact={selectedContact}
        />
        <ChatWindow
          selectedContact={selectedContact}
          endpointPrefix={endpointPrefix}
          setForceTokenExpired={setForceTokenExpired}
        />
      </Box>
    );
  };
}

export default ModoEspiao;
